import {
	GET_LEADS_SUCCESS,
	GET_LEADS_FAIL,
	GET_SALES_AGENTS_SUCCESS,
	GET_SALES_AGENTS_FAIL,
	OPEN_MODAL_SUCCESS,
	OPEN_MODAL_FAIL,
	CLOSE_MODAL_SUCCESS,
	CLOSE_MODAL_FAIL,
	GET_EXTRA_FORMS_SUCCESS,
	GET_EXTRA_FORMS_FAIL,
	GET_LEAD_BY_ID_SUCCESS,
	GET_LEAD_BY_ID_FAIL,
	DELETE_LEAD_BY_ID_SUCCESS,
	DELETE_LEAD_BY_ID_FAIL,
	GET_LEADS_APPOINTMENT_SUCCESS,
	GET_LEADS_APPOINTMENT_FAIL,
	GET_PENDING_DOC_SUCCESS,
	GET_PENDING_DOC_FAIL,
	SET_DEAL_STATUS_FILTER_BY_SUCCESS,
	SET_DEAL_STATUS_FILTER_BY_FAIL,
	CLEAR_DEAL_STATUS_FILTER_SUCCESS,
	CLEAR_DEAL_STATUS_FILTER_FAIL,
	SET_DEALS_SECTION,
	CLEAR_LEAD_BY_ID_SUCCESS,
} from './types';

const initialState = {
	leads: [],
	leadById: {},
	deletedLead: '',
	salesAgents: [],
	extraForms: [],
	modals: {
		clientDetails: false,
		addDocument: false,
		addLeads: false,
	},
	appointmentDetailByLeadId: {},
	pendingSignatures: [],
	filterDealBy: '',
	section: 'leads',
	loading: true,
};

export default function (state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case GET_LEADS_SUCCESS:
			return {
				...state,
				leads: payload,
				loading: false,
			};
		case GET_LEADS_FAIL:
			return {
				...state,
				leads: [],
				loading: false,
			};
		case GET_LEAD_BY_ID_SUCCESS:
			return {
				...state,
				leadById: payload,
				loading: false,
			};
		case GET_LEAD_BY_ID_FAIL:
			return {
				...state,
				leadById: [],
				loading: false,
			};
		case DELETE_LEAD_BY_ID_SUCCESS:
			return {
				...state,
				deletedLead: payload,
				loading: false,
			};
		case DELETE_LEAD_BY_ID_FAIL:
			return {
				...state,
				deletedLead: '',
				loading: false,
			};
		case GET_SALES_AGENTS_SUCCESS:
			return {
				...state,
				salesAgents: payload,
				loading: false,
			};
		case GET_SALES_AGENTS_FAIL:
			return {
				...state,
				salesAgents: [],
				loading: false,
			};
		case GET_EXTRA_FORMS_SUCCESS:
			return {
				...state,
				extraForms: payload,
				loading: false,
			};
		case GET_EXTRA_FORMS_FAIL:
			return {
				...state,
				extraForms: payload,
				loading: false,
			};
		case OPEN_MODAL_SUCCESS:
		case OPEN_MODAL_FAIL:
		case CLOSE_MODAL_SUCCESS:
		case CLOSE_MODAL_FAIL:
			return {
				...state,
				modals: {
					clientDetails: payload['clientDetails']
						? payload['clientDetails']
						: false,
					addDocument: payload['addDocument']
						? payload['addDocument']
						: false,
					addLeads: payload['addLeads'] ? payload['addLeads'] : false,
				},
				loading: false,
			};
		case GET_LEADS_APPOINTMENT_SUCCESS:
		case GET_LEADS_APPOINTMENT_FAIL:
			return {
				...state,
				appointmentDetailByLeadId: payload,
				loading: false,
			};
		case GET_PENDING_DOC_SUCCESS:
		case GET_PENDING_DOC_FAIL:
			return {
				...state,
				pendingSignatures: payload,
				loading: false,
			};
		case SET_DEAL_STATUS_FILTER_BY_SUCCESS:
		case SET_DEAL_STATUS_FILTER_BY_FAIL:
			return {
				...state,
				filterDealBy: payload,
				loading: false,
			};
		case CLEAR_DEAL_STATUS_FILTER_SUCCESS:
		case CLEAR_DEAL_STATUS_FILTER_FAIL:
			return {
				...state,
				filterDealBy: '',
				loading: false,
			};
		case SET_DEALS_SECTION:
			return {
				...state,
				section: payload,
				loading: false,
			};
		case CLEAR_LEAD_BY_ID_SUCCESS:
			return {
				...state,
				leadById: [],
			};
		default:
			return state;
	}
}
